import React, { ComponentType, useEffect } from 'react';
import {
  View,
  Stack,
  Spinner,
  Tabs,
} from '@piwikpro/ui-components';
import {
  Outlet,
  useLocation,
  useNavigate,
} from '@tanstack/react-router';
import { view, withInject } from '@piwikpro/platform';
import {
  TrackerSettings,
} from '../../TrackerSettings';

export interface GlobalAppSettingsProps {
  isLoading: boolean
  trackerSettings: TrackerSettings
  Title: ComponentType<any>
  t: Function
}
export const GlobalAppSettings: React.FC<GlobalAppSettingsProps> = ({
  isLoading,
  trackerSettings,
  Title,
  t,
}) => {
  const location = useLocation();
  const baseUrl = location.pathname.replace(/\/(data-collection|privacy)$/, '');
  // useNavigate() is typed to the host app's registered routes, but this package
  // is compiled in every app context (astronauth-ui etc.) where ppms-ui paths
  // are unknown. Cast once here so call sites stay clean.
  const navigate = useNavigate() as (opts: { to: string }) => void;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await trackerSettings.getDetails();
      // eslint-disable-next-line no-empty
      } catch (err) {}
    };
    fetchData();
  }, [trackerSettings]);

  if (isLoading) {
    return <Spinner type="centered" className="x-large" />;
  }

  return (
    <Title
      part={t('platform.globalWebsiteSettings.title')}
    >
      <View>
        <View.Header title={t('trackerSettings.globalWebsiteSettings.title')} />
        <View.Body>
          <Stack vertical horizontalAlignment="fill" spacing="wide">
            <Stack.Item>
              <Tabs
                active={location.pathname}
                RouterLink={null}
                setActive={(tab: 'data-collection' | 'privacy') => {
                  navigate({ to: tab });
                }}
                tabs={[
                  {
                    id: 'data-collection',
                    label: t('apps.details.tabs.data-collection'),
                    value: `${baseUrl}/data-collection`,
                  },
                  {
                    id: 'privacy',
                    label: t('apps.details.tabs.privacy'),
                    value: `${baseUrl}/privacy`,
                  },
                ]}
              />
            </Stack.Item>
            <Stack.Item>
              <Outlet />
            </Stack.Item>
          </Stack>
        </View.Body>
      </View>
    </Title>
  );
};

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  Title: 'TitleCrate.components.Title',
})(view({ role: 'OWNER' })(GlobalAppSettings as any));
